import { render, staticRenderFns } from "./link_order.vue?vue&type=template&id=6b0fb2dc&scoped=true&"
import script from "./link_order.vue?vue&type=script&lang=js&"
export * from "./link_order.vue?vue&type=script&lang=js&"
import style0 from "./link_order.vue?vue&type=style&index=0&id=6b0fb2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0fb2dc",
  null
  
)

export default component.exports